import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const permissionAPI = createApi({
    reducerPath: "permissionAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllPermissions: builder.mutation({
            query: () => {
                let apiUrl = `permissions`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["permissions"]
        }),
        createPermission: builder.mutation({
            query: ({body}) => ({
                url: `permissions`,
                method: "POST",
                body
            }),
            invalidatesTags: ["permissions"],
        }),
        updatePermission: builder.mutation({
            query: ({ id, body }) => ({
                url: `permissions/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["permissions"],
        }),

        getRolePermissionById: builder.mutation({
            query: ({id}) => {
                let apiUrl = `roles/${id}/permissions`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
    }),
});

export const {
    useGetAllPermissionsMutation,
    useCreatePermissionMutation,
    useUpdatePermissionMutation,

    useGetRolePermissionByIdMutation
} = permissionAPI;

export default permissionAPI;